import * as React from 'react';

function SvgFileArrowDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable={false}
      {...props}
    >
      <path
        d="M18.75 21H5.25a.75.75 0 01-.75-.75V3.75A.75.75 0 015.25 3h9l5.25 5.25v12a.75.75 0 01-.75.75z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 3v5.25h5.25M9.375 14.625L12 17.25l2.625-2.625M12 11.25v6"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgFileArrowDown;
